import {
  Application,
  ApplicationCardItem,
  Client,
  Owner,
  User,
  UserGroup,
} from "./types";

const transformApplicationCardData = (
  applications,
): Array<ApplicationCardItem> => {
  return applications?.map((app: Application) => ({
    logo: null,
    title: app?.name,
    description: app?.identifier,
  }));
};

const transformGroupData = (group): Array<UserGroup> => {
  return group.map((g) => ({
    groupId: g.group_id,
    name: g.name,
    isDept: g.is_dept,
    isRole: g.is_role,
  }));
};

const transformApplicationData = (group): Array<Application> => {
  const applicationsMap = new Map<number, Application>();
  group?.forEach((g) => {
    g.details.forEach((d) => {
      const app = d.application;
      if (!applicationsMap.has(app.application_id)) {
        applicationsMap.set(app.application_id, {
          applicationId: app.application_id,
          identifier: app.identifier,
          name: app.name,
        });
      }
    });
  });

  return Array.from(applicationsMap.values());
};

const transformClientOwnerData = (
  clientOwnerDetails,
): { clients: Array<Client>; owners: Array<Owner> } => {
  const clientsMap = new Map<number, Client>();
  const ownersMap = new Map<number, Owner>();
  clientOwnerDetails.forEach((cod) => {
    const client = cod.client;
    if (!clientsMap.has(client.client_id)) {
      clientsMap.set(client.client_id, {
        clientId: client.client_id,
        clientName: client.client_name,
        clientHubUrl: client.url_client_hub ?? null, // added
        clientInsightsUrl: client.url_client_insights ?? null, // added
      });
    }
    client.owners.forEach((owner) => {
      if (!ownersMap.has(owner.owner_id)) {
        ownersMap.set(owner.owner_id, {
          ownerId: owner.owner_id,
          ownerName: owner.owner_name,
        });
      }
    });
  });
  const clients: Array<Client> = Array.from(clientsMap.values());
  const owners: Array<Owner> = Array.from(ownersMap.values());
  return {
    clients,
    owners,
  };
};

const transformAuthData = (source: any): User => {
  const clientOwnerData = transformClientOwnerData(
    source?.clientOwnerDetails || [],
  );
  return {
    email: source.email,
    userId: source.user_id,
    firstName: source.first_name,
    lastName: source.last_name,
    isActive: source.is_active,
    isStaff: source.is_staff,
    isAdmin: source.is_admin,
    userType: source.user_type,
    permissions: source?.permissions,
    groups: transformGroupData(source?.group),
    applications: transformApplicationData(source?.group),
    clients: clientOwnerData?.clients,
    owners: clientOwnerData?.owners,
    clientHubUrl:
      clientOwnerData?.clients && clientOwnerData.clients.length > 0
        ? clientOwnerData.clients[0].clientHubUrl
        : null,
    clientInsightsUrl:
      clientOwnerData?.clients && clientOwnerData.clients.length > 0
        ? clientOwnerData.clients[0].clientInsightsUrl
        : null,
  };
};

export {
  transformAuthData,
  transformGroupData,
  transformApplicationData,
  transformClientOwnerData,
  transformApplicationCardData,
};
